module.exports = __webpack_public_path__ + "img/site3.a1727bc1.png";